import React from "react";

const ErrorModal = ({ isOpen, error, onRetry, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[251670017]">
      <div className="bg-white p-6 rounded shadow-xl text-center">
        <h2 className="text-xl font-bold text-red-600 mb-4">Error Occurred 🚨</h2>
        <p className="mb-4 text-gray-700">{error}</p>
        <div className="space-x-4">
          <button
            onClick={onRetry}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Retry
          </button>
          <button
            onClick={onClose}
            className="bg-gray text-white px-4 py-2 rounded hover:bg-gray-500"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
